import { ReactNode, useRef } from 'react';

import articleStyles from '../../article.module.css';
import {
	useShowComponent,
	Devices,
	OnOff,
	useComponentAnimation,
} from '../VirtualArticle.hooks';
export const VirtualColumns = (props: VirtualColumnsProps) => {
	const {
		id,
		bleed,
		animation,
		children,
		devices,
		expandfullwidth,
		multicolcount,
		multicolwidth,
		contentmode,
		background,
		imageurl,
	} = props;
	const ref = useRef(null);
	const animationClasses = useComponentAnimation({
		ref,
		animation,
	});
	const showClassName = useShowComponent(devices);

	const css: Array<string> = [];

	const classNames = [articleStyles['columns'], showClassName];

	const classNamesContainer = ['columns', ...animationClasses];

	if (expandfullwidth === 'on') {
		classNamesContainer.push('row-full');
	}

	if (bleed === 'on') {
		classNamesContainer.push('bleed');
	}

	if (multicolcount && multicolwidth && contentmode === 'multicol') {
		css.push(`#${id} > div > div {
			columns: ${multicolcount} ${multicolwidth}px;
			column-rule: 1px dotted #ddd;
			column-gap: 2rem;
		}`);
	}

	if (background === 'image' && imageurl) {
		css.push(`#${id} {
			background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url('${imageurl}');
			margin-left: auto;
			margin-right: auto;
			background-position: 50% 50%;
			justify-content: center;
		}`);
	}

	return (
		<section id={id} ref={ref} className={classNamesContainer.join(' ')}>
			<div className={classNames.join(' ')}>{children}</div>
			{css.length ? <style>{css.join('')}</style> : null}
		</section>
	);
};

interface VirtualColumnsProps {
	id: string;
	bleed: OnOff;
	collapsetype: string;
	animation: any;
	children: ReactNode;
	styles: Array<any>;
	colsplit: string | number;
	devices: Devices;
	multicolcount: any;
	multicolwidth: any;
	contentmode: any;
	expandfullwidth?: 'on' | 'off';
	background?: 'image';
	imageurl?: string;
}
